/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Score_LabelInputs */

const en_ats_score_label = /** @type {(inputs: Ats_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS Score`)
};

const de_ats_score_label = /** @type {(inputs: Ats_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-Score`)
};

const fr_ats_score_label = /** @type {(inputs: Ats_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score ATS`)
};

const es_ats_score_label = /** @type {(inputs: Ats_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuación ATS`)
};

const it_ats_score_label = /** @type {(inputs: Ats_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punteggio ATS`)
};

const nl_ats_score_label = /** @type {(inputs: Ats_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-score`)
};

const pl_ats_score_label = /** @type {(inputs: Ats_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wynik ATS`)
};

const fi_ats_score_label = /** @type {(inputs: Ats_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-pisteet`)
};

const da_ats_score_label = /** @type {(inputs: Ats_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-score`)
};

const sv_ats_score_label = /** @type {(inputs: Ats_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-poäng`)
};

/**
* | output |
* | --- |
* | "ATS Score" |
*
* @param {Ats_Score_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_score_label = /** @type {((inputs?: Ats_Score_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Score_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_score_label(inputs)
	if (locale === "fr") return fr_ats_score_label(inputs)
	if (locale === "es") return es_ats_score_label(inputs)
	if (locale === "it") return it_ats_score_label(inputs)
	if (locale === "nl") return nl_ats_score_label(inputs)
	if (locale === "pl") return pl_ats_score_label(inputs)
	if (locale === "fi") return fi_ats_score_label(inputs)
	if (locale === "da") return da_ats_score_label(inputs)
	if (locale === "sv") return sv_ats_score_label(inputs)
	return en_ats_score_label(inputs)
});